var map = {
	"./Courier.png": 7503,
	"./Courier.webp": 5548,
	"./bag.svg": 9260,
	"./canada-hero-old.jpg": 8633,
	"./canada-hero.jpg": 6725,
	"./canada-hero.webp": 2406,
	"./city.png": 9405,
	"./city.webp": 5342,
	"./country-svg/at.svg": 5675,
	"./country-svg/au.svg": 1482,
	"./country-svg/bg.svg": 1453,
	"./country-svg/ca.svg": 8460,
	"./country-svg/de.svg": 6669,
	"./country-svg/dk.svg": 363,
	"./country-svg/es.svg": 7392,
	"./country-svg/fr.svg": 3452,
	"./country-svg/gb.svg": 2539,
	"./country-svg/ie.svg": 3266,
	"./country-svg/it.svg": 9139,
	"./country-svg/lu.svg": 4245,
	"./country-svg/nl.svg": 418,
	"./country-svg/no.svg": 4465,
	"./country-svg/nz.svg": 1660,
	"./country-svg/pl.svg": 5920,
	"./country-svg/pt.svg": 3592,
	"./country-svg/ro.svg": 3781,
	"./courier-bike--og.png": 8717,
	"./courier-bike.png": 9137,
	"./courier-bike.webp": 8074,
	"./courier-car-uk.jpg": 4349,
	"./courier-car-uk.webp": 7345,
	"./courier-documents.jpg": 7442,
	"./courier-documents.webp": 8319,
	"./courier-group.png": 8357,
	"./courier-group.webp": 9414,
	"./courier-happy.png": 4346,
	"./courier-happy.webp": 9080,
	"./curior.svg": 4182,
	"./flexible.png": 5465,
	"./flexible.webp": 6034,
	"./hero-svg.svg": 1011,
	"./hour-glass.svg": 1359,
	"./iPhone copy.png": 9279,
	"./iPhones/iPhone-AUS.png": 6132,
	"./iPhones/iPhone-AUS.webp": 9033,
	"./iPhones/iPhone-CA-EN.png": 8977,
	"./iPhones/iPhone-CA-EN.webp": 1434,
	"./iPhones/iPhone-CA-FR.png": 1052,
	"./iPhones/iPhone-CA-FR.webp": 8849,
	"./iPhones/iPhone-ie.png": 4631,
	"./iPhones/iPhone-ie.webp": 9908,
	"./iPhones/iPhone-uk.png": 8733,
	"./iPhones/iPhone-uk.webp": 142,
	"./icons/chevron.svg": 8612,
	"./icons/close-black.svg": 7051,
	"./icons/close.svg": 9373,
	"./icons/flip.svg": 6158,
	"./icons/info-orange.svg": 7394,
	"./icons/info.svg": 5923,
	"./icons/nav-toggle.svg": 9835,
	"./icons/play-grey.svg": 5619,
	"./icons/play.svg": 7749,
	"./icons/tick.svg": 5160,
	"./logo/orange/logo_je.svg": 1130,
	"./logo/orange/logo_menulog.svg": 3646,
	"./logo/orange/logo_skip.svg": 7012,
	"./logo/white/logo_be.svg": 9679,
	"./logo/white/logo_je.svg": 2215,
	"./logo/white/logo_menulog.svg": 4633,
	"./logo/white/logo_nl.svg": 3186,
	"./logo/white/logo_pl.svg": 8576,
	"./ncc-logo.svg": 7822,
	"./pins.svg": 7098,
	"./sterling.png": 6908,
	"./support.svg": 7787
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1382;